import { ENROLLMENT_KIND } from '@theailab-dev/parchment';
import type { EnrollmentKind } from '@theailab-dev/parchment';

export function getKindLabel(kind: EnrollmentKind) {
  return kind === ENROLLMENT_KIND.PURCHASE ? '구매' : '부여';
}
